import React from 'react';
import contactImage from '../../../assets/luca_fantin_contact_us.png';
import ContactForm from '../../../components/contact_form/ContactForm';
import backgroundImage from '../../../assets/tGbms4_2_.png';

const ContactSection = ({t}) => {
    return (
        <section className="py-12 md:py-24 px-4 overflow-hidden">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
                    <div className="order-2 lg:order-1">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{t.title}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{t.subTitle}</h2>
                        <ContactForm t={t.form}/>
                    </div>
                    <div className="relative order-1 lg:order-2">
                        <img
                            src={backgroundImage}
                            alt=""
                            className="absolute top-1/2 left-0 z-0"
                            style={{
                                opacity: 0.35,
                                rotate: '-9deg',
                                transform: 'translate(-66%, -50%)',
                            }}
                            width={216}
                            height={216}
                        />
                        <img
                            src={contactImage}
                            alt="Contact Us"
                            className="object-cover relative z-10 md:h-96 lg:h-full rounded-lg shadow-md"
                            width={500}
                            height={750}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
